// Add your custom JS here.

(function ($) {
    $(window).on('load resize', function () {
    });
    function checkHeight(ele) {
        var h = 0;
        $(ele).each(function () {
            if ($(this).height() > h) {
                h = $(this).height();
            }
        });
        $(ele).css('height', h + 'px');
    }

    function setFullHeight() {
        document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);
    }

    window.addEventListener('resize', setFullHeight);
    setFullHeight();

    $(document).ready(function () {

        $(window).on('scroll', function () {
            if ($(window).scrollTop() > 100) {
                $('.toTop').addClass('active');
            } else {
                $('.toTop').removeClass('active');
            }
        });

        $('.toTop').on('click', function (e) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: 0
            }, 'swing');
        });

        $('.menu-item-has-children').append('<button type="button" class="btnSub"><i class="far fa-angle-down"></i></button>');

        $(document).on('click', '.btnSub', function (e) {
            e.preventDefault();
            $(this).toggleClass('active').siblings('.subMenu').slideToggle(300);
        });

        $(document).on('click', '.openMenu', function (e) {
            e.preventDefault();
            $('body').addClass('activeMenu');
        });

        $(document).on('click', '.closeMenu', function (e) {
            e.preventDefault();
            $('body').removeClass('activeMenu');
        });

        // AOS.init({ disable: 'mobile' });

        if ($('.fullPage').length) {
            const fullPage = new Swiper(".fullPage", {
                direction: "vertical",
                slidesPerView: 1,
                spaceBetween: 0,
                mousewheel: true,
                speed: 800,
                // parallax: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    renderBullet: function (index, className) {
                        return `<span class="${className}">${((index + 1) < 10) ? '0' + (index + 1) : (index + 1)}</span>`;
                    },
                },
                on: {
                    slideChange: function () {
                        if (this.activeIndex === 2 || this.activeIndex === 3) {
                            $('body').addClass('dark');
                        } else {
                            $('body').removeClass('dark');
                        }

                        setTimeout(() => {
                            if ($('.swiper-slide-active .process .figureNumber').length) {
                                $('.process .figureNumber').each(function () {
                                    runCounter($(this));
                                });
                            }
                        }, 800);
                    }
                }
            });
        }

        if ($('.homeSlider').length) {
            const homeSlider = new Swiper('.homeSlider', {
                loop: true,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                speed: 800,
            });
        }

        if ($('.homeProd__images').length) {
            const homeProdNav = new Swiper('.homeProd__thumbs', {
                slidesPerView: 4,
                spaceBetween: 20,
                // loop: true,
                autoplay: false,
                speed: 500,
                freeMode: true,
                watchSlidesProgress: true,
                navigation: {
                    nextEl: ".homeProd__thumbWrap .swiper-button-next",
                    prevEl: ".homeProd__thumbWrap .swiper-button-prev",
                },
                // Responsive breakpoints
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 3,
                        spaceBetween: 10
                    },
                    // when window width is >= 480px
                    480: {
                        slidesPerView: 3,
                        spaceBetween: 10
                    },
                    // when window width is >= 640px
                    640: {
                        slidesPerView: 3,
                        spaceBetween: 10
                    },
                    // when window width is >= 640px
                    991: {
                        slidesPerView: 4,
                        spaceBetween: 20
                    }
                }
            });
            const homeProdImage = new Swiper('.homeProd__images', {
                // loop: true,
                autoplay: false,
                effect: 'fade',
                speed: 500,
                thumbs: {
                    swiper: homeProdNav,
                },
            });
            const homeProdContent = new Swiper('.homeProd__content', {
                // loop: true,
                autoplay: false,
                effect: 'fade',
                speed: 500,
            });

            homeProdImage.on("slideChange", function () {
                homeProdContent.slideTo(homeProdImage.activeIndex);
            });
        }

        if ($('.homeApp__slider').length) {
            const homeApp = new Swiper('.homeApp__slider', {
                slidesPerView: 6,
                spaceBetween: 8,
                navigation: {
                    nextEl: ".homeApp__slider .swiper-button-next",
                    prevEl: ".homeApp__slider .swiper-button-prev",
                },
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                speed: 800,
                // Responsive breakpoints
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 2,
                        spaceBetween: 8
                    },
                    // when window width is >= 480px
                    480: {
                        slidesPerView: 2,
                        spaceBetween: 8
                    },
                    // when window width is >= 640px
                    640: {
                        slidesPerView: 3,
                        spaceBetween: 8
                    },
                    // when window width is >= 640px
                    991: {
                        slidesPerView: 6,
                        spaceBetween: 8
                    }
                }
            });
        }

        if ($('.homeNews__slider').length) {
            const homeApp = new Swiper('.homeNews__slider', {
                slidesPerView: 4,
                spaceBetween: 0,
                navigation: {
                    nextEl: ".homeNews__slider .swiper-button-next",
                    prevEl: ".homeNews__slider .swiper-button-prev",
                },
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                speed: 800,
                // Responsive breakpoints
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 8,
                        navigation: false
                    },
                    // when window width is >= 480px
                    480: {
                        slidesPerView: 1,
                        spaceBetween: 8,
                        navigation: false
                    },
                    // when window width is >= 640px
                    640: {
                        slidesPerView: 2,
                        spaceBetween: 8,
                        navigation: false
                    },
                    // when window width is >= 640px
                    640: {
                        slidesPerView: 4,
                        spaceBetween: 8,
                        navigation: false
                    }
                }
            });
        }

        if ($('.productSummary__images').length) {
            const prodThumbs = new Swiper('.productSummary__thumbs', {
                slidesPerView: "auto",
                spaceBetween: 6,
                direction: "vertical",
                // loop: true,
                autoplay: false,
                speed: 500,
                freeMode: true,
                watchSlidesProgress: true,
                navigation: {
                    nextEl: ".productSummary__thumbWrap .swiper-button-next",
                    prevEl: ".productSummary__thumbWrap .swiper-button-prev",
                },
            });
            const prodImages = new Swiper('.productSummary__images', {
                // loop: true,
                autoplay: false,
                spaceBetween: 12,
                // effect: 'fade',
                speed: 500,
                thumbs: {
                    swiper: prodThumbs,
                },
            });
        }

        if ($('.relatedProd__slider').length) {
            const relatedSlider = new Swiper('.relatedProd__slider', {
                slidesPerView: 3,
                spaceBetween: 24,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                speed: 800,
                navigation: {
                    nextEl: ".relatedProd__slider .swiper-button-next",
                    prevEl: ".relatedProd__slider .swiper-button-prev",
                },
                pagination: {
                    el: ".relatedProd__slider .swiper-pagination",
                    clickable: true,
                },
                // Responsive breakpoints
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 15,
                    },
                    // when window width is >= 480px
                    480: {
                        slidesPerView: 1,
                        spaceBetween: 15,
                    },
                    // when window width is >= 640px
                    640: {
                        slidesPerView: 2,
                        spaceBetween: 15,
                    },
                    // when window width is >= 640px
                    640: {
                        slidesPerView: 3,
                        spaceBetween: 15,
                    }
                }
            });
        }

        if ($('.relatedApp__slider').length) {
            const relatedSlider = new Swiper('.relatedApp__slider', {
                slidesPerView: 3,
                spaceBetween: 24,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                speed: 800,
                navigation: {
                    nextEl: ".relatedApp__slider .swiper-button-next",
                    prevEl: ".relatedApp__slider .swiper-button-prev",
                },
                pagination: {
                    el: ".relatedApp__slider .swiper-pagination",
                    clickable: true,
                },
                // Responsive breakpoints
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 15,
                    },
                    // when window width is >= 480px
                    480: {
                        slidesPerView: 1,
                        spaceBetween: 15,
                    },
                    // when window width is >= 640px
                    640: {
                        slidesPerView: 2,
                        spaceBetween: 15,
                    },
                    // when window width is >= 640px
                    991: {
                        slidesPerView: 3,
                        spaceBetween: 15,
                    }
                }
            });
        }

        if ($('.about4__slider').length) {
            const about4Slider = new Swiper('.about4__slider', {
                slidesPerView: 4,
                spaceBetween: 24,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                speed: 800,
                navigation: {
                    nextEl: ".about4__slider .swiper-button-next",
                    prevEl: ".about4__slider .swiper-button-prev",
                },
                pagination: {
                    el: ".about4__slider .swiper-pagination",
                    clickable: true,
                },
                // Responsive breakpoints
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 10,
                        navigation: false
                    },
                    // when window width is >= 480px
                    480: {
                        slidesPerView: 1,
                        spaceBetween: 10,
                        navigation: false
                    },
                    // when window width is >= 640px
                    640: {
                        slidesPerView: 2,
                        spaceBetween: 10,
                        navigation: false
                    },
                    // when window width is >= 640px
                    991: {
                        slidesPerView: 4,
                        spaceBetween: 10,
                        navigation: false
                    }
                }
            });
        }

        if ($('.about6__slider').length) {
            const about6Navs = new Swiper('.about6__navs', {
                slidesPerView: 5,
                spaceBetween: 0,
                // loop: true,
                autoplay: false,
                speed: 800,
                freeMode: true,
                watchSlidesProgress: true,
                navigation: false,
                rewind: true,
                // Responsive breakpoints
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 2,
                    },
                    // when window width is >= 480px
                    480: {
                        slidesPerView: 2,
                    },
                    // when window width is >= 640px
                    640: {
                        slidesPerView: 3,
                    },
                    // when window width is >= 640px
                    991: {
                        slidesPerView: 5,
                    }
                }
            });
            const about6Slider = new Swiper('.about6__slider', {
                slidesPerView: 1,
                spaceBetween: 24,
                parallax: true,
                rewind: true,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                speed: 1000,
                thumbs: {
                    swiper: about6Navs,
                },
                navigation: {
                    nextEl: ".about6__navWrap .swiper-button-next",
                    prevEl: ".about6__navWrap .swiper-button-prev",
                },
            });
        }


        function runCounter($element) {
            if (!$element.hasClass("counted")) { // Kiểm tra nếu chưa chạy
                var targetNumber = parseInt($element.html());
                $element.addClass("counted"); // Đánh dấu đã chạy
                $({ countNum: 0 }).animate({ countNum: targetNumber }, {
                    duration: 3000,
                    easing: "linear",
                    step: function () {
                        $element.text(Math.floor(this.countNum));
                    },
                    complete: function () {
                        $element.text(targetNumber);
                    }
                });
            }
        }
    });

})(jQuery)